export function gameDecisionCopy({
  type,
  mode,
  localTurn,
  gameType,
  sideName
}) {
  const isResign = type === 'resign';

  if (mode === 'online') {
    return {
      icon: isResign ? '⚑' : '½',
      title: isResign ? 'Đầu hàng ván này?' : 'Đề nghị hòa?',
      message: isResign
        ? 'Ván đấu sẽ kết thúc ngay và đối thủ được tính thắng. Bạn vẫn ở lại phòng để có thể yêu cầu chơi lại.'
        : 'Đề nghị hòa sẽ được gửi cho đối thủ. Ván chỉ kết thúc hòa nếu đối thủ chấp nhận.',
      confirm: isResign ? 'Đầu hàng' : 'Gửi đề nghị hòa',
      danger: isResign
    };
  }

  if (mode === 'bot') {
    return {
      icon: isResign ? '⚑' : '½',
      title: isResign ? 'Đầu hàng ván này?' : 'Kết thúc ván với kết quả hòa?',
      message: isResign
        ? 'Bạn sẽ đầu hàng và máy được tính thắng. Ván cờ hiện tại sẽ kết thúc.'
        : 'Ván luyện tập sẽ kết thúc ngay với kết quả hòa.',
      confirm: isResign ? 'Đầu hàng' : 'Chọn hòa',
      danger: isResign
    };
  }

  const loser = sideName(gameType, localTurn);
  const winner = sideName(gameType, localTurn === 'w' ? 'b' : 'w');

  return {
    icon: isResign ? '⚑' : '½',
    title: isResign ? `${loser} đầu hàng?` : 'Xác nhận hòa?',
    message: isResign
      ? `${loser} sẽ đầu hàng và ${winner} được tính thắng.`
      : 'Xác nhận hai người trên cùng thiết bị đồng ý kết thúc ván với kết quả hòa.',
    confirm: isResign ? 'Đầu hàng' : 'Chọn hòa',
    danger: isResign
  };
}

export function leaveRoomCopy({ gameType, onlineState, onlineUserSeat, onlineUserSide }) {
  const activePlayer = Boolean(
    onlineState?.status === 'active' &&
    (gameType === 'tycoon' ? Number.isInteger(onlineUserSeat) : Boolean(onlineUserSide))
  );

  if (activePlayer) {
    return gameType === 'tycoon'
      ? 'Bạn đang trong ván Cờ Tỷ Phú LIVE. Rời phòng sẽ loại bạn khỏi ván và giải phóng ghế sau khi máy chủ xác nhận.'
      : 'Bạn đang trong ván LIVE. Rời phòng sẽ kết thúc lượt tham gia của bạn, giải phóng bên đang giữ và đối thủ sẽ được ghi nhận là bên còn lại.';
  }

  const ownsSlot = gameType === 'tycoon' ? Number.isInteger(onlineUserSeat) : Boolean(onlineUserSide);
  if (ownsSlot) return 'Ghế/bên bạn đang giữ sẽ được giải phóng để thiết bị khác có thể chọn.';
  return 'Bạn sẽ rời khỏi phòng LIVE hiện tại.';
}
